import React, { useEffect, useState } from "react";
import "../../Styles/auth.css";
import { ReactComponent as LoginLogo } from "../../Assets/Auth/Login.svg";
import { ReactComponent as EmailLogo } from "../../Assets/Auth/Email.svg";
import { ReactComponent as PasswordLogo } from "../../Assets/Auth/Password.svg";
import { Link } from "react-router-dom";
import { clearErrors, login } from "../../Redux/Actions/authActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import OrgLogo from "../../Components/Other/logo";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";

const SignIn = () => {
  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error, isAuthenticated } = useSelector((state) => state.admin);

  useEffect(() => {
    document.title = "Sign In";

    if (error) {
      setErrorMessage(error?.data?.message);
      dispatch(clearErrors());
    }

    if (isAuthenticated) {
      // navigate("/dashboard", { replace: true }); //Change the route to home after testing
      window.location.href = "/dashboard";
    }
  }, [isAuthenticated, navigate, error, dispatch, errorMessage]);

  const handleSignIn = (e) => {
    e.preventDefault();
    dispatch(login(loginDetails));
  };

  const handleNavigation = (e) => {
    e.preventDefault();
    navigate("/forgot");
  };

  const handlePaymentExecNavigation = (event) => {
    event.preventDefault();
    navigate("/login_payment_exec");
  };

  return (
    <div className="login-container flex-container flex-center ">
      <OrgLogo />
      <div className="mid-container mirror-container">
        <div className="login-form flex-container flex-center flex-column">
          <div className="login-icon-container">
            <LoginLogo className="login-icon" />
          </div>
          <div className="login-title">
            <h2>Sign in with email</h2>
            <p>
              Sign in using your email to manage properties, track listings,
              <br /> and streamline your real estate operations effortlessly.
            </p>
          </div>
          <div className="login-input flex-container flex-row">
            <div className="login-input-icon-container">
              <EmailLogo className="login-input-icon" />
            </div>
            <input
              type="email"
              value={loginDetails.email}
              placeholder="Email"
              onChange={(e) =>
                setLoginDetails({ ...loginDetails, email: e.target.value })
              }
            />
          </div>
          <div className="login-input flex-container flex-row">
            <div className="login-input-icon-container">
              <PasswordLogo className="login-input-icon" />
            </div>
            <input
              type={showPassword ? "text" : "password"}
              value={loginDetails.password}
              placeholder="Password"
              onChange={(e) =>
                setLoginDetails({ ...loginDetails, password: e.target.value })
              }
              style={{ paddingRight: "30px" }} // to make space for the icon
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "50px",
                top: "58.5%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                color: "#000",
              }}
            >
              {showPassword ? (
                <AiOutlineEyeInvisible size={20} />
              ) : (
                <AiOutlineEye size={20} />
              )}
            </span>
          </div>
          <div className="login-forgot">
            <Link onClick={handleNavigation}>Forgot Password?</Link>
          </div>
          <div className="login-button width-100">
            <button
              onClick={handleSignIn}
              className="width-100 alt-black font-white font-SemiBold border-15"
            >
              Get Started
            </button>
          </div>
          <h4>Or</h4>
          <div className="login-button width-100">
            <button
              style={{ color: "black", background: "white" }}
              onClick={handlePaymentExecNavigation}
              className="width-100 alt-black font-white font-SemiBold border-15"
            >
              Login as other..
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
